import React, { useState } from 'react';
import { updatePassword } from "../../../Redux/actions/user";
import { connect } from "react-redux";
import { addNotification } from "../../../Utilities/notifications"; 
import "./index.css"; 

function SecuritySettings(props){

    const [loading, setLoading] = useState(false);
    let { user } = props;

    const handleUpdatePassword = async () => {
      setLoading(true);
      let data = await updatePassword(user);
      if(data.status === 200){
        addNotification({
          title: "Techforce.ai",
          message: "Update password link sent to registered email",
          type: "success"
        });
      }
      setLoading(false);
    }

    return (
      <div className="security-container">
        <div className="sub-head">
          <h2 className="heading">Security Settings</h2>
        </div>
        <div>
          <label>You will get a update password link when you click on Update Password</label>
        </div>
        <div>
          <button onClick={handleUpdatePassword} className="btn btn-primary">
              {loading ? "loading .." : "Update Password"}
          </button>
        </div>
      </div>
    );
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, null)(SecuritySettings);